import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';
import moment from 'moment';

class CmsExperienceStore {
  @observable data = [];
  @observable images = [];

  @observable experiences = [];
  @observable experience = null;

  @observable selectedexperience = null;
  @observable selectedimages = [];

  @observable showModal = false;
  @observable modalTitle = '';

  @observable updateLoading = false;

  @action getAll() {
    return apiCaller.CmsExperiences.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getAllByLanguage() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsExperiences.getActivesByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.experiences = resp;
      }
    })
  }

  @action getByIdAndLanguage(id) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsExperiences.getByIdAndLanguageCode(id, languageCode).then(resp => {
      if (resp) {
        this.selectedexperience = resp;
        this.selectedimages = [];
        if (this.selectedexperience.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.selectedexperience.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.selectedimages = imagesJson;
          } catch {
            this.selectedimages.push({
              id: v4(),
              url: this.selectedexperience.bannerUrl,
              isLoading: false
            });
          }
        }
      }
    })
  }

  @action getDataById(id) {
    this.modalTitle = 'Update Experience';
    return apiCaller.CmsExperiences.getById(id).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.images = [];
          this.experience = resp.data;

          const startDateTime = moment(this.experience.startDate);
          this.experience.startDateObject = startDateTime;
          this.experience.startTimeObject = startDateTime;

          const startEndTime = moment(this.experience.endDate);
          this.experience.endDateObject = startEndTime;
          this.experience.endTimeObject = startEndTime;

          if (this.experience.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.experience.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.images = imagesJson;
            } catch {
              this.images.push({
                id: v4(),
                url: this.experience.bannerUrl,
                isLoading: false
              });
            }
          }

          this.images.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.showModal = true;
        }
      }
    })
  }

  @action initCreate(languages) {
    this.modalTitle = 'Add Experience';

    this.experience = {
      'id': 0,
      'bannerUrl': '',
      'showDate': false,
      'showBannerOnly': false,
      'sort': 1,
      'experienceLanguages': []
    };

    const today = moment();
    this.experience.startDateObject = today;
    this.experience.startTimeObject = today;
    this.experience.endDateObject = today;
    this.experience.endTimeObject = today;

    languages.map(language => {
      this.experience.experienceLanguages.push({
        'id': 0,
        'experienceId': 0,
        'languageId': language.id,
        'title': '',
        'briefDescription': '',
        'description': ''
      });

      return language;
    })

    this.images = [{
      id: v4(),
      url: '',
      isLoading: false
    }];

    this.showModal = true;
  }

  @action create() {
    this.updateLoading = true;

    this.experience.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

    const startTimeObjectFormat = moment(this.experience.startTimeObject).format('HH:mm:00');
    this.experience.startDate = moment(`${moment(this.experience.startDateObject).format('YYYY-MM-DD')} ${startTimeObjectFormat}`);

    const endTimeObjectFormat = moment(this.experience.endTimeObject).format('HH:mm:00');
    this.experience.endDate = moment(`${moment(this.experience.endDateObject).format('YYYY-MM-DD')} ${endTimeObjectFormat}`);

    return apiCaller.CmsExperiences.create(this.experience);
  }

  @action update() {
    this.updateLoading = true;

    this.experience.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

    const startTimeObjectFormat = moment(this.experience.startTimeObject).format('HH:mm:00');
    this.experience.startDate = moment(`${moment(this.experience.startDateObject).format('YYYY-MM-DD')} ${startTimeObjectFormat}`);
    
    const endTimeObjectFormat = moment(this.experience.endTimeObject).format('HH:mm:00');
    this.experience.endDate = moment(`${moment(this.experience.endDateObject).format('YYYY-MM-DD')} ${endTimeObjectFormat}`);
    
    return apiCaller.CmsExperiences.update(this.experience.id, this.experience);
  }

  @action delete(id) {
    return apiCaller.CmsExperiences.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(value) {
    this.experience.sort = value;
  }

  @action setshowBannerOnly(value) {
    this.experience.showBannerOnly = value;
  }

  @action setshowDate(value) {
    this.experience.showDate = value;
  }

  @action setstartDateObject(value) {
    this.experience.startDateObject = value;
  }

  @action setstartTimeObject(value) {
    this.experience.startTimeObject = value;
  }

  @action setendDateObject(value) {
    this.experience.endDateObject = value;
  }

  @action setendTimeObject(value) {
    this.experience.endTimeObject = value;
  }

  @action settitle(langId, value) {
    let lang = this.experience.experienceLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.title = value;
    }
  }

  @action setbriefDescription(langId, value) {
    let lang = this.experience.experienceLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.briefDescription = value;
    }
  }

  @action setdescription(langId, value) {
    let lang = this.experience.experienceLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setImageUrlById(id, value) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.images.find(fi => fi.url === '');
    if (!blankImage) {
      this.images.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setImageIsLoadingById(id, isLoading) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeImageById(id) {
    this.images = this.images.filter(fi => fi.id !== id);
  }

  @action setexperience(value) {
    this.experience = value;
  }

  @action setupdateLoading(value) {
    this.updateLoading = value;
  }

  @action setshowModal(value) {
    this.showModal = value
  }

  @action resetData() {
    this.selectedexperience = null;
    this.selectedimages = [];
  }
}

export default new CmsExperienceStore();